import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import 'styles/tables.css';

const shouldShowPagination = (showPagination, resultCount, pageSize) => {
  if (showPagination !== undefined ? showPagination : true) {
    return resultCount > pageSize;
  }
  return false;
};

const BaseTable = ({
  className,
  columns,
  data,
  defaultFilterMethod,
  defaultSorted,
  defaultSortDesc,
  filterable,
  filtered,
  filteredArgs,
  loading,
  onFetchData,
  onFilteredChange,
  onPageChange,
  pages,
  resizable,
  resultCount,
  showPagination,
  style,
  tableRef,
}) => {
  const pageSize = 20;

  return (
    <ReactTable
      manual
      className={`-highlight ${className || ''}`}
      loadingText="Cargando..."
      pageSize={pageSize}
      defaultPageSize={10}
      minRows={1}
      pageText="Página"
      previousText="Anterior"
      nextText="Siguiente"
      noDataText="Sin resultados"
      rowsText="Filas"
      multiSort={false}
      showPageSizeOptions={false}
      showPagination={shouldShowPagination(showPagination, resultCount, pageSize)}
      ref={tableRef}
      resizable={resizable}
      data={data}
      loading={loading}
      pages={pages}
      filterable={filterable}
      filtered={filtered}
      filteredArgs={filteredArgs}
      columns={columns}
      defaultFilterMethod={defaultFilterMethod}
      defaultSorted={defaultSorted}
      defaultSortDesc={defaultSortDesc || false}
      onPageChange={onPageChange}
      onFetchData={onFetchData}
      onFilteredChange={onFilteredChange}
      style={style}
      getTheadProps={() => ({
        style: {
          background: '#EFEFEF',
          padding: '5px 0 5px 10px',
        }})
      }
      getTheadThProps={() => ({
        style: {
          border: 'none',
        }})
      }
      getTrGroupProps={() => ({
        style: {
          border: 'none',
          borderBottom: '1px solid #CCCCCC',
        }})
      }
      getTdProps={() => ({
        style: { border: 'none' },
      })}
      getTableProps={() => ({
        style: { overflowX: 'scroll' },
      })}
    />
  );
};

BaseTable.propTypes = [];

export default BaseTable;
